import { useTheme } from '../../../utils/theme-context';

const FAQ = [
	{
		title: 'What should I know about the company culture?'
	},
	{
		title: 'What resources can I access for professional development?'
	},
	{
		title: 'What should I focus on during my first week?'
	},
	{
		title: 'How can I best integrate into the team?'
	},
	{
		title: 'What are the key projects I should be aware of?'
	},
	{
		title: 'What are the best practices for communication within the team?'
	}
]

const Faqs = () => {
	const { theme } = useTheme();
	return (
		<div className='bg-gray-100 dark:bg-black rounded-3xl p-5'>
			<div className='w-full text-black font-medium text-base flex flex-row items-center py-2 mb-2'>
				<img src={theme === 'dark' ? '/svg/icons/faqs-white.svg' : '/svg/icons/faqs.svg'} className='mr-2 object-contain w-[20px]' alt='faqs' />
				<span className='dark:text-primary-darkMode'>Frequently asked questions</span>
			</div>
			{FAQ.map((faq, index: number) => (
				<div key={index + faq.title} className='w-full bg-white dark:bg-bgColor-darkMode rounded-lg p-3 flex flex-row items-center mt-1 mb-2 font-normal text-base text-gray-900 dark:text-primary-darkMode'>
					<span className='font-semibold text-base mr-2'>Q.</span>
					{faq.title}
				</div>
			))}
		</div>
	)
}

export default Faqs;